/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useContext } from 'react'
import { PageContext, PageContextValue } from './PageContext'

export const usePageContext = (): PageContextValue => {
  const context = useContext(PageContext)
  if (context === null) {
    throw new Error('PageContext missing - usePageContext must be used within a PageState provider')
  }

  return context
}
